// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__20SCz","icon":"icon__Ft2QK","fb":"fb__1tP0U","fbIntro":"fbIntro__2BdLU","tw":"tw__3Mjvk","twIntro":"twIntro__2RDrv","ig":"ig__Yn1Hj","igIntro":"igIntro__2SnVy","yt":"yt__ckOOh","ytIntro":"ytIntro__3PmV8","li":"li__2N_IL","liIntro":"liIntro__29u1y","pc":"pc__1DVm4","pcIntro":"pcIntro__cSrN5","tk":"tk__IVIIl"};


//////////////////
// WEBPACK FOOTER
// ./components/social/styles.styl
// module id = G5k/
// module chunks = 0